export const SET_LANGUAGE = 'SET_LANGUAGE'

export function setLanguage(language) {
  return {
    type: SET_LANGUAGE,
    language
  }
}



// WEBPACK FOOTER //
// ./src/actions/localization.js